import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/special-audit-detail',
      name: 'admin-special-audit-detail',
      component: () => import(/* webpackChunkName: "page-admin-tourism-product-management-special-audit-detail" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "产品确认详情"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "产品确认管理"
                                        },
                                        {
                                                  name: "确认列表"
                                        },
                                        {
                                                  name: " 产品确认详情"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
